import React from 'react';
import CalendarToday from '@mui/icons-material/CalendarToday';
import moment from 'moment-timezone';
import { WhiteTooltip } from '@AMIEWEB/Common/Tooltips/WhiteTooltip';

export const PastDueDateRenderer = props => {
  return (
    <WhiteTooltip title={'Past Due'}>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <CalendarToday style={{ height: '16px', width: '21px', color: '#CC0000' }} />
        <span style={{ color: '#CC0000' }}>{moment.tz(props?.date, 'America/Los_Angeles').format('L')}</span>
      </div>
    </WhiteTooltip>
  );
};
